import { QueryClient, QueryKey } from '@tanstack/react-query'

export const addOptimisticTask = <T extends { id: string }>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  task: T
) => {
  queryClient.setQueryData(queryKey, (old: T[] = []) => [task, ...old])
}

export const syncTaskInCache = <T extends { id: string }>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  task: T
) => {
  queryClient.setQueryData(queryKey, (old: T[] = []) =>
    old.map((t) => (t.id === task.id ? task : t))
  )
}

export const removeTaskFromCache = (
  queryClient: QueryClient,
  queryKey: QueryKey,
  taskId: string
) => {
  queryClient.setQueryData(queryKey, (old: { id: string }[] = []) =>
    old.filter((t) => t.id !== taskId)
  )
}
